module.exports = __webpack_public_path__ + "media/src/images/page01_t_workbook01-b6c0e492e96c7547fb4cb7a030221dd9.gif";